// extracted by mini-css-extract-plugin
export default {"examsList":"examsList___NVGlF","exam":"exam___u7Dmy"};